export default __webpack_public_path__ + "static/media/shaadi.b289a228.jpg";